module.exports = __webpack_public_path__ + "img/pa.a2629a2c.png";